import React from 'react';
import './HangmanGame.css';
import postIt from './Images/postIt.png';
import { useNavigate } from 'react-router-dom';

function HangmanGame() {
  const navigate = useNavigate();
  return (
    <div className="hangman-container">
      <header className="hangman-header">The Hangman Game</header>
      <main className="hangman-main">
        <div className="hangman-content">
          <img
            src={postIt} /* Replace with your image path */
            alt="Hangman Illustration"
            className="hangman-image"
          />
          <p className="hangman-description">
            Hangman is a classic word-guessing game where players must guess the given word or phrase letter by letter. 
            Each incorrect guess adds a part to the hangman figure. 
            The goal is to solve the word before the hangman is fully drawn!
          </p>
        </div>
      </main>
      <footer className="hangman-footer">
        <button className="hangman-button" onClick={() => navigate('/hangman-word', { state: { mode: 'word' } })} >Guess a Word</button>
        <button className="hangman-button" onClick={() => navigate('/hangman-word', { state: { mode: 'phrase' } })}>Guess a Phrase</button>
      </footer>
    </div>
  );
}

export default HangmanGame;
